import { SearchableOption } from '../../../types';
import { transformToCompetentNLBase } from '../CompetentNL/CompetentNLTransformers';
import { transformToSkillBase } from '../Skills/SkillsTransformers';
import {
    Education,
    EducationBase,
    EducationBaseResource,
    EducationResource,
} from './Educations';

export const transformToEducationBase = (resource: EducationBaseResource): EducationBase => {
    const base = transformToCompetentNLBase(resource);

    return {
        ...base,
        type: resource.type,
    };
};

export const transformToEducation = (resource: EducationResource): Education => {
    const educationBase = transformToEducationBase(resource);

    const essentialSkills = resource.essentialSkills
        ? resource.essentialSkills.map(transformToSkillBase)
        : [];

    return {
        ...educationBase,
        fullName: resource.fullName,
        isProfessionalRequirement: resource.isProfessionalRequirement,
        isBranchRequirement: resource.isBranchRequirement,
        educationLevel: resource.educationLevel,
        essentialSkills,
    };
};

export const transformEducationToSearchableOption = (education: Education): SearchableOption => ({
    value: education.id,
    label: education.label,
});
